import { Component, OnInit, Input, computed, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MemberService } from '@services/member.service';
import { LANGUAGES } from '@core/constants/language.constants';
import { LanguageService } from '@services/language.service';
import { Member } from '@models/member.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class LanguageSelectorComponent implements OnInit {
  static readonly LANGUAGE_COOKIE_NAME = 'eSelectedLanguage';

  @Input() notLoggedIn: boolean = false;
  currentMember: Member | null = null;

  private readonly languageService = inject(LanguageService);
  private readonly cookieService = inject(CookieService);
  readonly currentLanguage = computed(() =>
    this.languageService.currentLanguage(),
  );
  languages: string[] = [];

  constructor(private memberService: MemberService) {}

  ngOnInit(): void {
    this.initializeLanguages();
    if (!this.notLoggedIn) {
      this.loadCurrentMember();
    }
  }

  private initializeLanguages(): void {
    // Get supported languages from the service
    const supportedLangs = this.languageService.getSupportedLanguages();

    this.languages = supportedLangs.filter(lang => lang !== LANGUAGES.ZZ); // Filter out the test language
  }

  private loadCurrentMember(): void {
    this.memberService
      .current()
      .pipe(take(1))
      .subscribe((member: Member | null) => {
        if (member) {
          this.currentMember = member;
        }
      });
  }

  onLanguageChange(languageCode: string): void {
    if (this.notLoggedIn) {
      this.cookieService.set(
        LanguageSelectorComponent.LANGUAGE_COOKIE_NAME,
        languageCode,
        365,
        '/',
        '',
        true,
        'Lax',
      );
      this.languageService.setMemberLanguage(languageCode, LANGUAGES.DE);
      return;
    }

    if (!this.currentMember) {
      return;
    }

    // Update member's language
    this.currentMember.language = languageCode;

    // Save the member with updated language
    this.currentMember.save().subscribe(
      () => {
        // Update the language service
        this.languageService.setMemberLanguage(
          languageCode,
          this.currentMember?.companySetting?.language || LANGUAGES.EN,
        );
      },
      error => {
        console.error('Error updating language:', error);
        // Revert on error
        this.loadCurrentMember();
      },
    );
  }
}
